import { useLocation } from 'react-router-dom';
import { Routes } from '../../routes/top-level-routes';

export const isLeadGeneratorBuilderRoute = (path: string) =>
  path === `${Routes.freeLeadGenerator.path}/start` ||
  path === `${Routes.automatedResponseTool.path}/start`;

export const useIsLeadGeneratorBuilderRoute = (): boolean => {
  const { pathname } = useLocation();
  return isLeadGeneratorBuilderRoute(pathname);
};

export const useIsAnyLeadGeneratorBuilderRoute = (): boolean => {
  const { pathname } = useLocation();
  return (
    pathname.includes(Routes.freeLeadGenerator.path) ||
    pathname.includes(Routes.automatedResponseTool.path)
  );
};
